export const privatePersonMixins = {
    data () {
      return {
        professions: [
          'Recreational Aviator',
          'Aviation Mechanist',
          'Aviation Industry professional',
          "Aviation Engineer",
          'Professional Pilot',
          'Aviation Scholar',
          'Drone Operator',
          'Commercial Crew',
          'Aviation Enthusiast',
          'Flight Instructor',
          "Air Traffic Controller",
          'Other'
        ],
      }
    },
  }